import { gql } from "@apollo/client";

const SAVE_SOURCE_BUNDLE_MUTATION = gql`
  mutation save_source_bundle($name: String!, $status: String) {
    save_source_bundle(name: $name, bundle: { status: $status }) {
      ok
    }
  }
`;

const SAVE_EXPORT_MUTATION = gql`
  mutation save_export($name: String!, $status: String) {
    save_export(name: $name, export: { status: $status }) {
      ok
    }
  }
`;

export { SAVE_SOURCE_BUNDLE_MUTATION, SAVE_EXPORT_MUTATION };
